<template>
  <router-view />
  <AppSnackbar />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useTheme } from "@/core/theme/useTheme";
import AppSnackbar from "@/shared/components/AppSnackbar.vue";

onMounted(() => {
  const { initTheme } = useTheme();
  initTheme();
});
</script>

<style>
/* Global styles */

/* Tooltip for Required fields (used across AppInput, SlideOvers, etc.) */
.required-asterisk {
  color: var(--color-danger, #ef4444);
  margin-left: 4px;
  cursor: help;
  position: relative;
  font-weight: 700;
}

.required-asterisk::after {
  content: "Este campo es obligatorio";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-8px);
  background-color: var(--color-text-primary, #111827);
  color: var(--color-background, #ffffff);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  pointer-events: none;
  z-index: 9999;
  box-shadow: var(--shadow-sm, 0 1px 2px 0 rgba(0, 0, 0, 0.05));
  font-weight: 500;
}

.required-asterisk:hover::after {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(-4px);
}
</style>
